import { render } from "./FilterBadge.vue?vue&type=template&id=49ba93aa"
import script from "./FilterBadge.vue?vue&type=script&lang=js"
export * from "./FilterBadge.vue?vue&type=script&lang=js"
script.render = render

export default script